(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["auralis-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var root = document.querySelector('.auralis-bundle');
    if (!root) return;

    var tiers = root.querySelectorAll('.auralis-bundle__tier');
    var candles = root.querySelectorAll('.auralis-bundle__candle');
    var statusEl = root.querySelector('[data-bundle-status]');
    var atcBtn = root.querySelector('[data-bundle-atc]');
    var defaultTier = parseInt(root.dataset.defaultTier, 10) || 2;

    var state = {
      qty: defaultTier,
      price: 0,
      selected: []
    };

    /* --- Init: set default tier price --- */
    tiers.forEach(function (t) {
      if (parseInt(t.dataset.tierQty, 10) === defaultTier) {
        state.price = parseFloat(t.dataset.tierPrice);
      }
    });

    /* --- Init: preselect first N candles --- */
    candles.forEach(function (c, i) {
      if (i < defaultTier) {
        state.selected.push(c.dataset.variantId);
      }
    });

    updateUI();

    /* --- Tier selection --- */
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        state.qty = parseInt(tier.dataset.tierQty, 10);
        state.price = parseFloat(tier.dataset.tierPrice);

        /* Reset candle selection: preselect first N */
        state.selected = [];
        candles.forEach(function (c, i) {
          if (i < state.qty) {
            state.selected.push(c.dataset.variantId);
          }
        });

        updateUI();
      });
    });

    /* --- Candle toggle --- */
    candles.forEach(function (candle) {
      candle.addEventListener('click', function () {
        var vid = candle.dataset.variantId;
        var idx = state.selected.indexOf(vid);

        if (idx > -1) {
          /* Deselect */
          state.selected.splice(idx, 1);
        } else if (state.selected.length < state.qty) {
          /* Select */
          state.selected.push(vid);
        }

        updateUI();
      });
    });

    /* --- Add to Cart --- */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (state.selected.length !== state.qty) return;
        if (atcBtn.dataset.state === 'loading') return;

        atcBtn.dataset.state = 'loading';
        atcBtn.disabled = true;

        var items = state.selected.map(function (vid) {
          return { id: parseInt(vid, 10), quantity: 1 };
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function () {
          atcBtn.dataset.state = 'done';

          /* Open cart drawer if available */
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            setTimeout(function () { cartDrawer.open(); }, 400);
          } else {
            /* Fallback: dispatch cart update event */
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }

          setTimeout(function () {
            atcBtn.dataset.state = '';
            atcBtn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          atcBtn.dataset.state = '';
          atcBtn.disabled = false;
        });
      });
    }

    /* --- Hide default buy buttons --- */
    var buyBlock = root.closest('.group-block, .product-details');
    if (buyBlock) {
      var buyButtons = buyBlock.querySelector('[class*="buy-button"], .buy-buttons');
      if (buyButtons) buyButtons.style.display = 'none';
    }

    /* --- Update UI --- */
    function updateUI() {
      /* Tiers */
      tiers.forEach(function (t) {
        var q = parseInt(t.dataset.tierQty, 10);
        var isSelected = q === state.qty;
        t.classList.toggle('auralis-bundle__tier--selected', isSelected);
        t.setAttribute('aria-pressed', String(isSelected));
      });

      /* Candles */
      candles.forEach(function (c) {
        var vid = c.dataset.variantId;
        var isSelected = state.selected.indexOf(vid) > -1;
        var isFull = state.selected.length >= state.qty;

        c.classList.toggle('auralis-bundle__candle--selected', isSelected);
        c.classList.toggle('auralis-bundle__candle--disabled', !isSelected && isFull);
        c.setAttribute('aria-pressed', String(isSelected));
      });

      /* Status */
      if (statusEl) {
        var remaining = state.qty - state.selected.length;
        if (remaining > 0) {
          statusEl.textContent = 'Choose ' + remaining + ' candle' + (remaining > 1 ? 's' : '') + ' to continue';
          statusEl.dataset.complete = 'false';
        } else {
          statusEl.textContent = 'Perfect selection ✓';
          statusEl.dataset.complete = 'true';
        }
      }

      /* ATC button */
      if (atcBtn && atcBtn.dataset.state !== 'loading' && atcBtn.dataset.state !== 'done') {
        atcBtn.disabled = state.selected.length !== state.qty;
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
